/*
  Даты в интерфейсе — одно место на всё приложение.

  Их было два, и они разъехались: кабинет писал «17 сентября 2026 г.», разбор
  заявок — «17.09.2026, 04:58». В макетах формат один: «14 сентября», а у
  свежего — «сегодня, 14:02» и «вчера, 22:15». Год дописывается только к
  чужому: почти всё на экранах случилось на днях, и «2026» у каждой строки
  читалось канцелярской припиской.
*/

import { t } from '../../i18n';

const DAY = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' });
const DAY_YEAR = new Intl.DateTimeFormat('ru-RU', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});
const TIME = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit' });

export function formatDate(value: string | null | undefined): string {
  const date = toDate(value);
  if (date === null) return '—';
  if (date.getFullYear() === new Date().getFullYear()) return DAY.format(date);
  // Intl дописывает к году « г.», и форматом это не отменить.
  return DAY_YEAR.format(date).replace(' г.', '');
}

/** То же плюс время, а у сегодняшнего и вчерашнего — словом, как в макете. */
export function formatDateTime(value: string | null | undefined): string {
  const date = toDate(value);
  if (date === null) return '—';

  const day = daysApart(date);
  if (day === 0) return t('lib.date.today', { time: TIME.format(date) });
  if (day === 1) return t('lib.date.yesterday', { time: TIME.format(date) });
  return formatDate(date.toISOString());
}

function toDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Сколько СУТОК назад, а не часов: «вчера в 23:50» вчерашнее и в час ночи. */
function daysApart(date: Date): number {
  return Math.round((startOfDay(new Date()) - startOfDay(date)) / 86_400_000);
}

function startOfDay(value: Date): number {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime();
}
